export const getUniLogoSrc = (assetsUrl: string): string => {
  const domain = window.location.host.split('.')[0];
  return `${assetsUrl}/branding/${domain}/images/uni_logo.png`;
};
